import React from 'react'
import Button from '../../DMGComponents/Button'
import Input from '../../DMGComponents/Input'
import Spinner from '../Spinner'
import Break from '../../DMGComponents/Break'
import { searchExternalUsersAdmin, setUserBlacklist } from '../../fetchData'
import toast, { Toaster } from 'react-hot-toast'
import { confirmAlert } from 'react-confirm-alert'
import '../../assets/css/react-confirm-alert.css'

class AdminUsers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            users: [],
            isSearching: false,
            hasSearched: false,
        }
    }

    handleSearch = () => {
        const { searchText } = this.state
        if (!searchText.trim()) {
            toast.error('Enter an email address to search.')
            return
        }
        this.setState({ isSearching: true, hasSearched: true })
        searchExternalUsersAdmin(searchText).then(res => {
            this.setState({ users: res || [], isSearching: false })
        }).catch(() => {
            toast.error('Error searching users.')
            this.setState({ isSearching: false })
        })
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') this.handleSearch()
    }

    handleBlacklist = (user, shouldBlacklist) => {
        const action = shouldBlacklist ? 'blacklist' : 'remove from blacklist'
        const message = shouldBlacklist
            ? `Blacklist "${user.email}"? This will remove all area permissions for this user immediately.`
            : `Remove "${user.email}" from the blacklist?`
        confirmAlert({
            title: shouldBlacklist ? 'Blacklist User' : 'Remove from Blacklist',
            message,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        setUserBlacklist(user.email, shouldBlacklist).then(() => {
                            this.setState(prev => ({
                                users: prev.users.map(u =>
                                    u.email === user.email ? { ...u, isBlacklisted: shouldBlacklist } : u
                                )
                            }))
                            toast.success(`User ${shouldBlacklist ? 'blacklisted' : 'unblacklisted'}.`)
                        }).catch(() => {
                            toast.error(`Error: could not ${action} user.`)
                        })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { return }
                }
            ]
        })
    }

    render() {
        const { searchText, users, isSearching, hasSearched } = this.state
        return (
            <div style={{ textAlign: 'left' }}>
                <Toaster />
                <Break style={{ margin: '16px 0 12px 0' }}>External User Management</Break>

                <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                        <Input
                            value={searchText}
                            onClick={val => this.setState({ searchText: val })}
                            onKeyDown={this.handleKeyDown}
                            label="Search by email address..."
                        />
                    </div>
                    <Button type="hover-bottom-left" onClick={this.handleSearch} disabled={isSearching}>Search</Button>
                </div>

                <p style={{ fontSize: '0.85em', color: '#666', marginBottom: '12px' }}>
                    Blacklisting a user removes all their area permissions immediately and prevents future access.
                </p>

                {isSearching && <div style={{ textAlign: 'center' }}><Spinner /></div>}
                {!isSearching && hasSearched && users.length === 0 && <p>No external users found.</p>}
                {!isSearching && users.length > 0 &&
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Email</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>First name</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Last name</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Company</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Status</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, i) => (
                                <tr key={i} className="searchContent"
                                    style={user.isBlacklisted ? { color: '#c00' } : {}}>
                                    <td style={{ padding: '4px 8px' }}>{user.email}</td>
                                    <td style={{ padding: '4px 8px' }}>{user.firstName}</td>
                                    <td style={{ padding: '4px 8px' }}>{user.lastName}</td>
                                    <td style={{ padding: '4px 8px' }}>{user.company}</td>
                                    <td style={{ padding: '4px 8px' }}>
                                        {user.isBlacklisted ? <strong>Blacklisted</strong> : 'Active'}
                                    </td>
                                    <td style={{ padding: '4px 8px' }}>
                                        {user.isBlacklisted
                                            ? <Button type="hover-bottom-left" onClick={() => this.handleBlacklist(user, false)}>Unblacklist</Button>
                                            : <Button type="hover-bottom-left" onClick={() => this.handleBlacklist(user, true)}>Blacklist</Button>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}

export default AdminUsers
